import { INCREMENT, DECREMENT, PAGENO, ALL_PAGES_NO, MOBILE_IMAGE_COUNT, DESKTOP_IMAGE_COUNT } from './actions';

let initialValue = {
  count: 0,
  pageNo: [1],
  allPagesNo: [],
  totalMobImages: 0,
  totalDeskImages: 0
}

const userReducer = (state = initialValue, action) => {

  switch(action.type) {

    case INCREMENT: {
      return {
        ...state, 
        count: state.count+1
      }
    }

    case DECREMENT: {
      return {
        ...state, 
        count: state.count-1
      }
    }

    case PAGENO: {
      console.log("reducer", action.payload)
      return {
        ...state, 
        pageNo: [...state.pageNo, action.payload]
      }
    }

    case ALL_PAGES_NO: {
      console.log("reducer", action.payload)
      return {
        ...state, 
        allPagesNo: action.payload
      }
    }

    case MOBILE_IMAGE_COUNT: {
      return {
        ...state, 
        totalMobImages: action.payload
      }
    }

    case DESKTOP_IMAGE_COUNT: {
      return {
        ...state, 
        totalDeskImages: action.payload
      }
    }

    default: {
      return state;
    }

  }
}

export default userReducer;
 